import api from '$lib/api'
import * as userActions from '$actions/users'

export const sendRealtimeNotificationUser = async (userId, message) => {
    
    const res = await api.post('/realtime/demo/senduser', {
        userId,
        message,
    })
    
    return res
    
}

export const sendRealtimeNotificationUserEmail = async (email, message) => {
    
    const user = await userActions.getUserByEmail(email)
    
    return sendRealtimeNotificationUser(user.id, message)
    
}

export const sendRealtimeNotificationOrg = async (organizationId, message) => {
    
    const res = await api.post('/realtime/demo/sendorg', {
        organizationId,
        message,
    })
    
    return res
    
}

// @todo /demo/sendorgsamples

export const updateRealtimeNotification = async (notificationId, data = {}) => {
    
    const res = await api.post(`/realtime/demo/update/${notificationId}`, {
        data,
    })
    
    return res
    
}

export const dismissRealtimeNotification = async notificationId => {
    
    const res = await api.delete(`/realtime/demo/dismissbroadcast/${notificationId}`)
    
    return res
    
}
